// extracted by mini-css-extract-plugin
module.exports = {"liveElementPlaceholder":"liveElements_liveElementPlaceholder__8E9bx"};